export default {
  list: [
    {
      title: 'آماده سرویس',
      value: 'READY'
    },
    {
      title: 'غیرفعال',
      value: 'DISABLE'
    },
    {
      title: 'در‌انتظار پاسخ کافی‌شاپ',
      value: 'WAITING_FOR_CAFE_RESPONSE'
    },
    {
      title: 'رزرو شد',
      value: 'RESERVED'
    }
  ],
  values: {
    READY: 'READY',
    WAITING_FOR_CAFE_RESPONSE: 'WAITING_FOR_CAFE_RESPONSE',
    DISABLE: 'DISABLE',
    RESERVED: 'RESERVED'
  }
}